module.exports = __webpack_public_path__ + "static/media/strip.4ebb569a.JPG";